import React, { FC, useCallback, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Grid } from '@mui/material'
import { IntroducerStatusEnum } from '@sparling/financial-common'
import { useDispatch, useSelector } from 'react-redux'
import { InputField } from '../../../components/InputField'
import { Modal } from '../../../components/Modal'
import { IData } from '../UserProfileTabs'
import { introducerSuspendResolver } from './resolvers'
import { canUpdateUserDetails, introducerDataUpdateRequest } from '../../../store/actions'
import { introducerCanUpdateUserDetails } from '../../../store/selectors'

interface IntroducerSuspendModalProps extends Pick<IData, 'idSf'> {
  isOpen: boolean
  modalClose: () => void
  refresh?: () => void
}

export const IntroducerSuspendModal: FC<IntroducerSuspendModalProps> = ({ isOpen, modalClose, idSf, refresh }) => {
  const dispatch = useDispatch()
  const canUpdate = useSelector(introducerCanUpdateUserDetails)
  const formMethods = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    shouldFocusError: true,
    resolver: introducerSuspendResolver,
  })
  const {
    handleSubmit,
    reset,
    formState: { isValid },
  } = formMethods

  const onSubmit = useCallback(
    (data) => {
      if (idSf)
        dispatch(
          introducerDataUpdateRequest({
            idSf,
            ...data,
            introducerStatus: IntroducerStatusEnum.SUSPENDED,
          }),
        )
      reset()
      modalClose()
    },
    [dispatch, idSf, modalClose, reset],
  )

  useEffect(() => {
    if (canUpdate && refresh) {
      dispatch(canUpdateUserDetails(false))
      refresh()
    }
  }, [dispatch, canUpdate, refresh])

  return (
    <Modal
      title="Introducer Suspend"
      submitTitle="Suspend"
      isOpen={isOpen}
      modalClose={modalClose}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitDisabled={!isValid}
    >
      <FormProvider {...formMethods}>
        <Grid container direction="column" minHeight={180}>
          <Grid item xs={12}>
            <InputField
              labelName={'Suspend Reason'}
              inputName="introducerSuspensionReason"
              inputType="text"
              rows={6}
              withoutPadding
              fullWidth
              multiline
            />
          </Grid>
        </Grid>
      </FormProvider>
    </Modal>
  )
}
